/**
 * Datadog error helpers for Site-Wide Jackpot MDS operations.
 */

import type { TRumError } from './types';

export type SwjContext = {
    jackpotId: string;
};

/**
 * Creates a Datadog error for MDS initialization failures.
 */
export const ddErrorMdsInit = (error: Error, context: SwjContext): TRumError => ({
    name: 'SITE_WIDE_JACKPOT_INIT_MDS_FAILED',
    description: 'Site wide jackpot init mds failed.',
    stack: error,
    use_case: 'SITE_WIDE_JACKPOT',
    context: { ...context }
});

/**
 * Creates a Datadog error for MDS message handling failures.
 */
export const ddErrorMdsHandleMessage = (error: Error, context: SwjContext): TRumError => ({
    name: 'SITE_WIDE_JACKPOT_HANDLE_MDS_MSG_FAILED',
    description: 'Site wide jackpot handle mds message failed.',
    stack: error,
    use_case: 'SITE_WIDE_JACKPOT',
    context: { ...context }
});

/**
 * Creates a Datadog error for opt-in status check failures.
 */
export const ddErrorSwjCheckOptinStatus = (error: Error, context: SwjContext): TRumError => ({
    name: 'SITE_WIDE_JACKPOT_CHECK_OPTIN_STATUS_FAILED',
    description: 'Site wide jackpot check optin status failed.',
    stack: error,
    use_case: 'SITE_WIDE_JACKPOT',
    context: { ...context }
});

/**
 * Creates a Datadog error for opt-in/opt-out operation failures.
 */
export const ddErrorSwjOptin = (
    errorMessage: string | undefined,
    useCase: 'SITE_WIDE_JACKPOT',
    context: Record<string, unknown>
): TRumError => ({
    name: 'SITE_WIDE_JACKPOT_OPTIN_FAILED',
    description: 'Site wide jackpot user optin failed.',
    stack: errorMessage ?? '',
    use_case: useCase,
    context
});
